/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Link as GatsbyLink } from 'gatsby';

/**
 * This Link component helps in using the same Link component for internal and external links.
 * Taken from the official Gatsby documentation.
 */
export default function Link({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}) {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external. Also filters for file downloads.
  const internal = /^\/(?!\/)/.test(to) || /\.[0-9a-z]+$/i.test(to);
  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }
  return (
    <a href={to} {...other}>
      {children}
    </a>
  );
}
